<template>
  <div>
    <v-btn class="btn-add-category btn-add-history" :aria-label="$t('Документы')" @click.native.stop="documentDialog = true">
      <v-icon class="file-document-icon" aria-hidden="true">mdi-file-document-edit-outline</v-icon>
      <slot></slot>
    </v-btn>
    <v-dialog v-model="documentDialog" max-width="940">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Документы') }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="documentDialog = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <v-btn v-if="historyEditable && documentsUpload" class="btn-add-category btn-add-default"
                 :aria-label="$t('Добавить документ')"
                 @click.native.stop="isAdding = true">
            <span class="pro-icon-add" aria-hidden="true"></span> {{ $t('Добавить документ') }}
          </v-btn>
          <div v-if="isAdding" class="documents-add">
            <v-form
              class="form-ru"
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="createDocument"
            >
              <div class="form-group">
                <div class="row" :class="{ invalid: $v.documentFile.documentType.$error }">
                  <div class="col-sm-3">
                    <label for="documentType">
                      {{ $t("Тип документа") }}
                    </label>
                  </div>
                  <div class="col-sm-9">
                    <v-select
                      id="documentType"
                      item-value="id"
                      item-text="transName"
                      v-model="documentFile.documentType"
                      :items="refDocumentType"
                      input="transName"
                      outlined
                      rounded
                      dense
                    ></v-select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="row" :class="{ invalid: $v.documentFile.uploadedFile.$error }">
                  <div class="col-sm-3">
                    <label for="file">
                      {{ $t("Файл") }}
                    </label>
                  </div>
                  <div class="col-sm-9">
                    <div class="file-item">
                      <div class="file-item_flex">
                        <i
                          aria-hidden="true"
                          class="v-icon notranslate v-icon--link mdi mdi-paperclip theme--light"
                        ></i>
                        <v-file-input
                          :label="$t('Выберите файл')"
                          v-model="documentFile.uploadedFile"
                          class="v-input__control"
                        >
                        </v-file-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-action">
                <button
                  class="btn btn-default blue"
                  type="submit"
                >
                  {{ $t('Добавить') }}
                </button>
                <button
                  class="btn btn-default white"
                  type="button"
                  @click="onCancel"
                >
                  {{ $t('Отмена') }}
                </button>
              </div>
            </v-form>
          </div>
          <div class="table-overflow">
            <table class="table-cell-fix">
              <thead>
              <tr>
                <td class="td-docs">
                  {{ $t('Тип документа') }}
                </td>
                <td v-if="historyEditable && documentsUpload" class="td-action">
                  {{ $t('Действия') }}
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="document in documents" :key="document.id">
                <td>
                  <a class="file-link" :href="baseUrl + document.fullFilePath" target="_blank">
                    <i
                      class="docs-icon"
                      :class="document.fullFilePath.substr(document.fullFilePath.length - 3) == 'pdf' ? 'pro-icon-pdf' : 'pro-icon-doc'"
                      aria-hidden="true"
                    />{{ document.transName }}
                  </a>
                </td>
                <td class="td-action" v-if="historyEditable && documentsUpload">
                  <v-btn class="btn-add btn-delete" :aria-label="$t('Удалить документ') + ': ' + document.transName" @click.native.stop="deleteDocument(document.id)">
                    <v-icon aria-hidden="true">delete_forever</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Npa from '@/model/npa'
import {required} from 'vuelidate/lib/validators'
import {mapMutations} from 'vuex'


export default {
  props: {
    npaPromotionHistoryId: Number,
    historyEditable: Boolean,
    documentsUpload: Boolean
  },
  data: () => ({
    documents: [],
    refDocumentType: [],
    documentFile: [],
    documentDialog: false,
    baseUrl: process.env.VUE_APP_BACK_URL,
    isAdding: false,
    rules: {
      documentFile: {
        uploadedFile: {required},
        documentType: {required}
      }
    },
    valid: true
  }),
  created() {
    this.fetchData()
  },
  validations() {
    return this.rules
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      Npa.getNpaPromotionHistoryDocumentList(this.npaPromotionHistoryId)
        .then((res) => {
          this.documents = res.data.documents
          this.refDocumentType = res.data.refDocumentType
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
    },
    createDocument() {
      if (!this.validateForm()) return

      this.setLoading(true)
      const f = this.$refs.form.$el
      const formData = new FormData(f)

      formData.append('npa_promotion_history_document[uploadedFile]', this.documentFile.uploadedFile)
      formData.append('npa_promotion_history_document[documentType]', this.documentFile.documentType)


      Npa.createNpaPromotionHistoryDocument(this.npaPromotionHistoryId, formData)
        .then((res) => {
          if (res.status === 201) {
            this.documents = res.data.documents
            this.onCancel()
            this.setLoading(false)
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.data.npaPromotionHistoryDocumentForm) {
              let npaPromotionHistoryForm = err.response.data.npaPromotionHistoryDocumentForm
              const message = npaPromotionHistoryForm.data.errors.errors[0]
              this.$noty.error(this.$i18n.t(message), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            }
          }
          this.setLoading(false)
        })
    },
    deleteDocument(id) {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        Npa.deleteNpaPromotionHistoryDocument(id)
          .then((res) => {
            this.documents = res.data.documents
            this.setLoading(false)
          })
          .catch((err) => {
            console.log(err)
            this.setLoading(false)
          })
      }
    },
    onCancel() {
      this.isAdding = false
      this.documentFile = {}
      this.$v.$reset()
    },
    // Валидация формы
    validateForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    scrollToFirstError() {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.col-sm-2,
.col-sm-3,
.col-sm-9,
.col-sm-10 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.form-files {
  label {
    min-width: auto;
  }
}

.files {
  .file-item {
    display: flex;

    i {
      position: relative;
      top: -4px;
    }

    .v-input {
      max-width: 240px;
      margin: 0;
      padding: 0;
      white-space: nowrap;
    }
  }
}

.documents-add {
  margin-bottom: 50px;
}
</style>
